export default __webpack_public_path__ + "static/media/native-apps.e9887bf1.svg";